import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Stats = function Stats(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.93555 10.8333C1.93555 9.91286 2.68174 9.16667 3.60221 9.16667H6.93555C7.85602 9.16667 8.60221 9.91286 8.60221 10.8333V15.8333C8.60221 16.7538 7.85602 17.5 6.93555 17.5H3.60221C2.68174 17.5 1.93555 16.7538 1.93555 15.8333V10.8333ZM6.93555 10.8333H3.60221V15.8333H6.93555V10.8333Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.93555 7.5C6.93555 6.57952 7.68174 5.83333 8.60221 5.83333H11.9355C12.856 5.83333 13.6022 6.57953 13.6022 7.5V15.8333C13.6022 16.7538 12.856 17.5 11.9355 17.5H8.60221C7.68174 17.5 6.93555 16.7538 6.93555 15.8333V7.5ZM11.9355 7.5H8.60221V15.8333H11.9355V7.5Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.9355 4.16667C11.9355 3.24619 12.6817 2.5 13.6022 2.5H16.9355C17.856 2.5 18.6022 3.24619 18.6022 4.16667V15.8333C18.6022 16.7538 17.856 17.5 16.9355 17.5H4.01888V15.8333H11.9355V4.16667ZM16.9355 4.16667H13.6022V15.8333H16.9355V4.16667Z",
      fill: color
    })]
  });
};
export default Stats;